import { callAPI } from '../../../services/api.service';

export interface ProjectTemplateOption {
  id: string;
  name: string;
  wpProjectId: string;
  wpTitle?: string;
  wpExcerpt?: string;
  wpLink?: string;
  wpDateList?: string;
  wpSyncedAt?: any;
}

export interface WpMediaResource {
  wpMediaId: number;
  title: string;
  sourceUrl: string;
  thumbnailUrl?: string;
  mimeType: string;
  mediaType: string;
  altText?: string;
}

/**
 * Fetch available project templates for the template dropdown.
 * Cached WP metadata (wpExcerpt, wpLink) is included for instant switching.
 */
export const getAvailableProjectTemplates = async (): Promise<ProjectTemplateOption[]> => {
  try {
    const response = await callAPI('api/project-templates/available');
    return response?.templates || [];
  } catch (error) {
    console.error('Failed to fetch available project templates:', error);
    return [];
  }
};

/**
 * Fetch a single project template by ID (includes cached WP metadata).
 */
export const getProjectTemplateById = async (
  templateId: string,
): Promise<ProjectTemplateOption | null> => {
  try {
    const response = await callAPI(`api/project-templates/${templateId}`);
    return response?.template || null;
  } catch (error) {
    console.error('Failed to fetch project template:', error);
    return null;
  }
};

/**
 * Fetch WordPress resource media for a project template (live from WP, not cached).
 * Used by the Publishing Kit gallery popup.
 */
export const getProjectTemplateResources = async (
  templateId: string,
): Promise<WpMediaResource[]> => {
  const response = await callAPI(`api/project-templates/${templateId}/resources`, null, 'GET');
  if (!response || response.status >= 400) {
    throw new Error(response?.error || 'Failed to fetch resources from WordPress');
  }
  return response?.resources || [];
};
